import React from 'react';
import { Link } from 'react-router-dom';
import { FaHeart } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const handleSocialClick = (platform) => {
    console.log(`Opening ${platform}`);
  };

  return (
    <footer className="bg-gray-950 text-gray-300 w-full">
      <div className="container mx-auto px-4 sm:px-6 py-8">
        {/* Grid layout - Mobile: 2 columns, Tablet/Desktop: 4 columns */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {/* About Section - Full width on mobile, normal on desktop */}
          <div className="col-span-2 md:col-span-1 flex flex-col">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-14 h-14 flex items-center justify-center overflow-hidden flex-shrink-0">
                <img
                  src="/images/logo.png"
                  alt="Katine TTI Logo"
                  className="max-w-full max-h-full w-auto h-auto object-contain"
                  style={{ width: 'auto', height: 'auto', maxWidth: '100%', maxHeight: '100%' }}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.style.display = 'none';
                    e.target.parentElement.innerHTML = '<span className="text-secondary font-bold text-3xl">K</span>';
                  }}
                />
              </div>
              <h3 className="text-secondary text-lg font-semibold">Katine TTI</h3>
            </div>
            <p className="text-gray-400 text-sm">
              Katine Technical Training Institute - Transforming Potential Into Technical Expertise.
            </p>
          </div>

          {/* Quick Links - Column 1 */}
          <div className="flex flex-col">
            <h3 className="text-secondary text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-400 hover:text-secondary text-sm transition-colors">Home</Link></li>
              <li><Link to="/search" className="text-gray-400 hover:text-secondary text-sm transition-colors">Search Graduates</Link></li>
              <li><Link to="/gown-request" className="text-gray-400 hover:text-secondary text-sm transition-colors">Request Gown</Link></li>
            </ul>
          </div>

          {/* Contact Info - Column 2 */}
          <div className="flex flex-col">
            <h3 className="text-secondary text-lg font-semibold mb-4">Contact Info</h3>
            <ul className="space-y-3 text-gray-400 text-sm">
              <li className="flex items-center space-x-3">
                <span className="text-base w-5">📞</span>
                <span>+254719 508 039</span>
              </li>
              <li className="flex items-center space-x-3">
                <span className="text-base w-5">✉️</span>
                <span>info@katinetti.ac.ke</span>
              </li>
              <li className="flex items-center space-x-3">
                <span className="text-base w-5">📍</span>
                <span>Tala Machakos</span>
              </li>
              <li className="flex items-center space-x-3">
                <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.66 0 3-4 3-9s-1.34-9-3-9m0 18c-1.66 0-3-4-3-9s1.34-9 3-9m-9 9a9 9 0 019-9" />
                </svg>
                <a
                  href="https://www.katinetti.ac.ke"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-secondary transition-colors"
                >
                  www.katinetti.ac.ke
                </a>
              </li>
            </ul>
          </div>

          {/* Social Links - Full width on mobile, normal on desktop */}
          <div className="col-span-2 md:col-span-1 flex flex-col">
            <h3 className="text-secondary text-lg font-semibold mb-4">Follow Us</h3>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/katine.TTI/"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => handleSocialClick('Facebook')}
                className="text-gray-400 hover:text-secondary transition-colors"
                aria-label="Follow us on Facebook"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.879v-6.99h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.99C18.343 21.128 22 16.991 22 12z"/>
                </svg>
              </a>
              <a
                href="https://www.tiktok.com/@katine.technical?is_from_webapp=1&sender_device=pc"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => handleSocialClick('TikTok')}
                className="text-gray-400 hover:text-secondary transition-colors"
                aria-label="Follow us on TikTok"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Desktop view - horizontal layout */}
        <div className="hidden md:flex flex-row items-center justify-between gap-4 mt-8 pt-6 border-t border-gray-800">
          <p className="text-gray-400 text-sm">
            © {currentYear} Katine Technical Training Institute. All rights reserved.
          </p>
          <p className="text-gray-400 text-sm text-center">
            Transforming Potential into Technical Expertise
          </p>
          <p className="text-gray-400 text-sm flex items-center gap-1">
            Made with <FaHeart className="w-3 h-3 text-red-500 animate-pulse" /> for Katine TTI
          </p>
        </div>

        {/* Mobile view - stacked */}
        <div className="flex flex-col items-center gap-2 md:hidden mt-8 pt-6 border-t border-gray-800">
          <p className="text-gray-400 text-xs text-center">
            © {currentYear} Katine Technical Training Institute. All rights reserved.
          </p>
          <p className="text-gray-400 text-xs text-center">
            Transforming Potential into Technical Expertise
          </p>
          <p className="text-gray-400 text-xs flex items-center justify-center gap-1">
            Made with <FaHeart className="w-3 h-3 text-red-500 animate-pulse" /> for Katine TTI
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
